import { render, staticRenderFns } from "./boardcastBigViewList.vue?vue&type=template&id=6bd33732&scoped=true"
import script from "./boardcastBigViewList.vue?vue&type=script&lang=ts"
export * from "./boardcastBigViewList.vue?vue&type=script&lang=ts"
import style0 from "./boardcastBigViewList.vue?vue&type=style&index=0&id=6bd33732&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd33732",
  null
  
)

export default component.exports